import type { AssistantPendingMutation } from "@/types/account";

type Props = {
  mutations: AssistantPendingMutation[];
  disabled: boolean;
  onConfirm: (id: string) => void;
  onDecline: (id: string) => void;
  onConfirmAll?: () => void;
};

export default function AssistantMutationPrompt({
  mutations,
  disabled,
  onConfirm,
  onDecline,
  onConfirmAll
}: Props) {
  if (!mutations.length) return null;

  const pendingCount = mutations.filter((m) => (m.status || "pending") === "pending").length;
  const showConfirmAll = pendingCount >= 2 && Boolean(onConfirmAll);

  return (
    <div className="creaAsstMutations">
      {mutations.map((m) => {
        const status = m.status || "pending";
        const isPending = status === "pending";
        const isRunning = status === "running";
        return (
          <div key={m.id} className={"creaAsstMutationCard" + (status !== "pending" && status !== "running" ? " resolved" : "")}>
            <div className="creaAsstMutationLabel">{m.label}</div>
            {isPending ? (
              <div className="creaAsstMutationActions">
                <button
                  type="button"
                  className="creaAsstMutationBtn creaAsstMutationBtn--confirm"
                  disabled={disabled}
                  onClick={() => onConfirm(m.id)}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="creaAsstMutationBtn creaAsstMutationBtn--decline"
                  disabled={disabled}
                  onClick={() => onDecline(m.id)}
                >
                  Cancel
                </button>
              </div>
            ) : isRunning ? (
              <div className="creaAsstMutationStatus muted">Running…</div>
            ) : status === "confirmed" ? (
              <div className="creaAsstMutationStatus creaAsstMutationStatus--ok">Completed</div>
            ) : status === "declined" ? (
              <div className="creaAsstMutationStatus muted">Cancelled</div>
            ) : (
              <div className="creaAsstMutationStatus creaAsstMutationStatus--err">
                Failed{m.error ? `: ${m.error}` : ""}
              </div>
            )}
          </div>
        );
      })}
      {showConfirmAll ? (
        <div className="creaAsstMutationConfirmAll">
          <button
            type="button"
            className="creaAsstMutationBtn creaAsstMutationBtn--confirm"
            disabled={disabled}
            onClick={() => onConfirmAll?.()}
          >
            Confirm all ({pendingCount})
          </button>
        </div>
      ) : null}
    </div>
  );
}
